module.exports = __webpack_public_path__ + "img/my.1bedd026.png";